import React, { ReactElement } from 'react';
import TableRow from '../table-row/table-row.component';
import FormatService from '../../services/format-service';
import useStylesTableRowGroupHeader from './table-row-group-header.styles';

const TableRowGroupHeader: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isSticky,
    isHidden,
    isEdit,
    children,
  } = props;

  const { classes } = useStylesTableRowGroupHeader();

  const stickyClassName: string | undefined = isSticky ? classes.tableRowGroupHeaderSticky : undefined;
  const stickyEditClassName: string | undefined = isSticky && isEdit
    ? classes.tableRowGroupHeaderStickyEdit : undefined;
  const hiddenClassName: string | undefined = isHidden ? classes.tableRowGroupHeaderHidden : undefined;

  return (
    <TableRow className={FormatService.formatClassNames(stickyClassName, stickyEditClassName, hiddenClassName)}>
      {children}
    </TableRow>
  );
});

export default TableRowGroupHeader;
